<!-- ヘッダーナビゲーションバー -->
<template>
  <div class="nav-bar">
    <div class="nav-bar__inner">
      <router-link to="/Karada-Diary" v-if="$route.path !== '/SignIn'">
        <img
          src="../../static/svg/menu_logo_mirai.svg"
          class="nav-bar--content nav-bar--content__logo"
        />
      </router-link>

      <img
        src="../../static/svg/menu_logo_mirai.svg"
        class="nav-bar--content nav-bar--content__logo"
        v-else
      />

      <router-link to="/Karada-Diary" v-if="isSignIn">
        <header-menu-icon
          :imgSource="NoteIcon"
          :iconLabel="$t('menu.karadaNote')"
          :displayLabel="isWindowFull"
        />
      </router-link>

      <div class="nav-bar--content__dropdown">
        <header-menu-icon
          v-if="isSignIn"
          :imgSource="ChartIcon"
          :iconLabel="$t('menu.karadaKarte')"
          :displayLabel="isWindowFull"
          dropdown
          data-test="chart-icon"
        />

        <div class="nav-bar--content__dropdown--content">
          <ul>
            <!-- 診断を始める -->
            <router-link
              to="/AI-Diesease-Prediction"
              data-test="start-prediction"
            >
              <li class="nav-bar--content__dropdown--content--item">
                {{ $t("menu.startPrediction") }}
              </li>
            </router-link>
            <!-- 過去の診断データ -->
            <router-link to="/result-list" data-test="result-list">
              <li class="nav-bar--content__dropdown--content--item">
                診断結果一覧
              </li>
            </router-link>
          </ul>
        </div>
      </div>

      <div class="nav-bar--content__dropdown">
        <header-menu-icon
          v-if="isSignIn"
          :imgSource="SettingIcon"
          :iconLabel="$t('menu.configuration')"
          :displayLabel="isWindowFull"
          dropdown
        />

        <div class="nav-bar--content__dropdown--content">
          <ul>
            <router-link
              :to="{ name: 'account', params: { source: 'profile' } }"
            >
              <li class="nav-bar--content__dropdown--content--item">
                {{ $t("menu.profile") }}
              </li>
            </router-link>
          </ul>
        </div>
      </div>

      <div class="nav-bar--content__dropdown" data-test="user-icon">
        <div class="nav-bar--content__right" v-if="isSignIn">
          <div class="user-name" v-if="isWindowFull">{{ getNickName }}</div>
          <img :src="UserIcon" alt="icon" class="icon-img" />
        </div>

        <div class="nav-bar--content__dropdown--content">
          <ul>
            <!--
            <router-link to="/csv-upload" data-test="csv-upload">
            <li
              class="nav-bar--content__dropdown--content--item"
            >CSVアップロード</li>
          </router-link>
          -->
            <li
              class="nav-bar--content__dropdown--content--item"
              @click="signOut"
              data-test="logout"
            >
              {{ $t("auth.logout") }}
            </li>
          </ul>
        </div>
      </div>

      <router-link to="/SignUp" v-if="isSignUpLink">
        <div class="signup">{{ $t("auth.signUp") }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import HeaderTitle from "../components/atoms/HeaderNavigation/Title";
import UserIcon from "../components/atoms/HeaderNavigation/UserIcon";
import HeaderMenuIcon from "../components/atoms/HeaderNavigation/HeaderMenuIcon";

import ChartOff from "../../static/svg/menu_chart_off.svg";
import ChartOn from "../../static/svg/menu_chart_on.svg";
import NoteOff from "../../static/svg/menu_note_off.svg";
import NoteOn from "../../static/svg/menu_note_on.svg";
import SettingOff from "../../static/svg/menu_setting_off.svg";
import SettingOn from "../../static/svg/menu_setting_on.svg";
import UserOff from "../../static/svg/menu_user_off.svg";
import UserOn from "../../static/svg/menu_user_on.svg";

import firebase from "firebase";

export default {
  data() {
    return {
      /* icons */
      ChartOff: ChartOff,
      ChartOn: ChartOn,
      NoteOff: NoteOff,
      NoteOn: NoteOn,
      SettingOff: SettingOff,
      SettingOn: SettingOn,
      UserOff: UserOff,
      UserOn: UserOn,

      width: window.innerWidth,
    };
  },
  components: {
    UserIcon,
    HeaderTitle,
    HeaderMenuIcon,
  },
  computed: {
    /* pathに合致するとき(アクティブなとき)は、Onを使う */
    NoteIcon() {
      if (this.$route.path === "/Karada-Diary") {
        return NoteOn;
      } else {
        return NoteOff;
      }
    },
    ChartIcon() {
      if (
        this.$route.path === "/AI-Diesease-Prediction" ||
        this.$route.path === "/notes"
      ) {
        return ChartOn;
      } else {
        return ChartOff;
      }
    },
    SettingIcon() {
      if (this.$route.path === "setting") {
        return SettingOn;
      } else {
        return SettingOff;
      }
    },
    UserIcon() {
      if (this.$route.path === "user") {
        return UserOn;
      } else {
        return UserOff;
      }
    },
    isWindowFull() {
      if (this.width >= 1024) {
        return true;
      } else {
        return false;
      }
    },
    //TODO リンクを消すパスを配列で管理するようにリファクタリング
    isSignIn() {
      if (
        this.$route.path === "/" ||
        this.$route.path === "/SignIn" ||
        this.$route.path === "/SignUp" ||
        this.$route.path === "/Wellcho/signIn" ||
        this.$route.path === "/Reset" ||
        this.$route.path === "/Error"
      ) {
        return false;
      } else {
        return true;
      }
    },
    isSignUpLink() {
      if (this.$route.path === "/" || this.$route.path === "/SignIn") {
        return true;
      } else {
        return false;
      }
    },
    getNickName() {
      return this.$store.state.users.nickname || "username";
    },
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          alert(this.$t("auth.doLogout"));
          this.$store.dispatch("clearAll");
          this.$router.push({ name: "signIn" });
        })
        .catch((error) => {
          alert(this.$t("auth.failedLogout"));
          console.log(`サインアウトでエラーが発生しました (${error})`);
        });
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.nav-bar {
  position: fixed;
  background-color: #419be0;
  width: 100%;
  z-index: 1;
}
.nav-bar__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  width: 80vw;
  margin: auto;
}
.nav-bar--content__right {
  display: flex;
  align-items: center;
}
.nav-bar--content__right:hover {
  cursor: pointer;
}
.user-name {
  margin-right: 10px;
  color: #ffffff;
}
.signup {
  margin-right: 10px;
  color: #ffffff;
  font-weight: bold;
}
a {
  text-decoration: none;
  color: #293845;
}
a:hover {
  text-decoration: none;
  color: #293845;
}

.nav-bar--content__logo {
  height: 50px;
  width: 15vw;
}

.nav-bar--content__dropdown:hover {
  cursor: pointer;
}
/*TODO 右側に飛び出ないように調整する */
.nav-bar--content__dropdown--content {
  position: absolute;
  visibility: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  min-width: 60px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  box-sizing: border-box;
  padding: 0 5px;
}
.nav-bar--content__dropdown--content--item {
  margin-top: 5px;
}
.nav-bar--content__dropdown--content--item:hover {
  opacity: 0.7;
}

.nav-bar--content__dropdown:hover .nav-bar--content__dropdown--content {
  visibility: visible;
}
.nav-bar--content__dropdown--content > ul {
  list-style: none;
  text-align: left;
  margin: 0;
  padding: 10px 10px;
}
.icon-img {
  height: 30px;
  width: 30px;
}
</style>
